<template>
    <div>
        <div class="listbanner">
            <a href="javascript:;" title="芙清故事">
                <img src="http://www.fulqun.com/images/pagebanner.jpg" alt />
            </a>
        </div>
        <div class="listbox">
            <div class="list-show">
                <div class="title">
                    <em>
                        芙清故事
                        <span></span>
                    </em>
                </div>
                <div class="show">
                    <div>
                        <div>
                            <strong>&ldquo;芙清&rdquo;二字的由来</strong>
                        </div>
                        <div>
                            芙清二字，取自李白《经乱离后天恩流夜郎忆旧游书怀赠江夏韦太守良宰》中的&ldquo;清水出芙蓉，天然去雕饰&rdquo;。
                            <span
                                style="color: rgb(0, 0, 0); font-family: Arial, SimSun; font-size: 14px; text-indent: 28px;">自然之美，是对&ldquo;</span>
                            <span
                                style="color: rgb(0, 0, 0); font-family: Arial, SimSun; font-size: 14px; text-indent: 28px;">芙清追寻清透健康肌肤本源</span>
                            <span
                                style="color: rgb(0, 0, 0); font-family: Arial, SimSun; font-size: 14px; text-indent: 28px;">&rdquo;这一价值理念的诠释</span>。
                        </div>
                        <div>&nbsp;</div>
                        <div>
                            <strong>品牌理念</strong>
                        </div>
                        <div>
                            FulQun芙清提出&ldquo;有痘痘，用FulQun芙清&rdquo;的口号。多年来，FulQun芙清始终以改善痘痘肌肤为己任，专注研发有效的护理产品，帮助更多被痘痘困扰的人群，让他们更加阳光自信地拥抱未来。
                        </div>
                        <div>&nbsp;</div>
                        <div>
                            <strong>科研成果</strong>
                        </div>
                        <div>
                            FulQun芙清自诞生之日起就秉承着&ldquo;产学研相结合&rdquo;的理念，时刻紧跟科研脚步，将最前沿、最优质的研究成果应用于新品开发当中，从一轮又一轮的临床检验中精选出最匹配痘肌肤质的配方。
                        </div>
                        <div>&nbsp;</div>
                        <div>
                            抗菌肽（十三肽），取自东北林蛙表皮细胞再经生物工程发酵而得，是由吉林蓝鼎陆和科技有限公司和吉林大学生命科学院联合研发而成，广谱抗菌性等特点。2018年抗菌肽（十三肽）及其制备技术获得国家专利。
                        </div>
                    </div>
                    <div>
                        <strong>专利名称</strong>：一种十三肽抗菌敷料及其制备方法&nbsp;
                    </div>
                    <div>
                        <strong>专&nbsp; 利&nbsp; 号</strong>：201811055495 .2
                    </div>
                    <div>
                        <div>
                            <strong>临床优势</strong>
                        </div>
                        <div>FulQun芙清品牌的核心成分抗菌肽（十三肽），经过了北大医院、北京友谊医院、江苏省人民医院的临床试验。</div>
                        <div>&nbsp;</div>
                        <div>
                            <img alt src="http://www.fulqun.com/uploadfile/2019/0902/20190902030000499.jpg" />
                        </div>
                    </div>
                    <div>
                        <div>&nbsp;</div>
                        <div>
                            <strong>FulQun芙清品牌大事记</strong>
                        </div>
                        <div>2013年 FulQun芙清抗菌功能性敷料（贴），即FulQun芙清经典款面膜研发成功。</div>
                        <div>2014年 FulQun芙清品牌在中国隆重上市。</div>
                        <div>2016年 全国数十家大型三甲医院临床权威验证FulQun芙清的有效性及安全性。</div>
                        <div>2017年 全国500多家公立机构和1000多家私立机构广泛应用FulQun芙清。</div>
                        <div>2018年成为第三届中国中医美容大会合作单位。抗菌肽（十三肽）获得国家专利。</div>
                        <div>2019年3月中国中西医结合学会皮肤性病专业委员会突出贡献奖。</div>
                        <div>4月与巴斯夫签订医疗及医美领域PatcH2O&trade;商标的使用授权。</div>
                        <div>7月推出FulQun芙清凉茶面膜，打造国风医美潮牌，引爆全网。</div>
                        <div>&nbsp;</div>
                    </div>
                    <p>
                        <img alt src="http://www.fulqun.com/uploadfile/2019/0902/20190902025821956.jpg"
                            style="width:60%;" />
                    </p>
                    <p>&nbsp;</p>
                    <div>
                        <strong>品牌荣誉</strong>
                    </div>
                    <div>
                        <img alt src="http://www.fulqun.com/uploadfile/2019/0902/20190902055437774.jpg" />
                    </div>
                    <div>&nbsp;</div>
                    <div>&nbsp;</div>
                </div>
            </div>
        </div>
        <el-divider></el-divider>
        <div class="footer">
            <ul class="putbox">
                <li>芙清fulqun官网</li>
                <li>Beijing FulQun Bio-Technology Co. Ltd</li>
                <li>北京芙清生物科技有限公司©</li>
                <li>地址：北京市丰台区南四环西路186号汉威国际广场二区9号楼6层03-07室</li>
                <li>
                    <a href="https://beian.miit.gov.cn/">京ICP备19037671号-1</a>
                </li>
                <li @click="() => { this.$router.push('/img') }">
                    互联网药品信息服务资格证书
                </li>
            </ul>
            <div class="contactbox">
                <p>400-010-2266</p>
                <p>周一至周五 9:00-17:30</p>
                <p>在线客服</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {
        go() {
            this.$router.push('/certification')
        }
    },
};
</script>

<style lang="less" scoped>
.listbanner {
    width: 100%;
    overflow: hidden;
}

.listbanner img {
    width: 100%;
    height: auto;
    display: block;
}

.listbox {
    width: 100%;
    margin: 2rem 0;
}

.list-show {
    width: 80%;
    margin: 0 auto;
    max-width: 1000px;
}

.list-show .title {
    text-align: center;
    color: #1e456f;
    position: relative;
}

.show {
    color: #313131;
    line-height: 28px;
    margin: 1rem 0;
}

.list-show .title em {
    font-size: 16px;
    font-weight: 500;
    position: relative;
    border-bottom: solid 5px #e13837;
    padding-bottom: 0.5rem;
}

.show div,
.show p {
    text-indent: 28px;
}

.show img {
    display: block;
    width: 100%;
    margin: 0 auto;
}

.show div strong,
.show p strong {
    margin-left: -28px;
}

.footer {
    height: 200px;
    padding: 30px;
    background-color: rgb(250, 250, 250);
    display: flex;
    justify-content: space-between;
}

.putbox {
    list-style: none;
    font-size: 12px;
    width: 70%;
    margin-top: 10px;
    padding-left: 10%;
    line-height: 30px;
}

.putbox a {
    text-decoration: none;
    color: #666;
}

.contactbox {
    width: 30%;
    height: 100%;
    text-align: center;
    line-height: 50px;
}

.contactbox p:nth-child(1) {
    color: rgb(65, 110, 179);
    font-size: 28px;
}

.contactbox p:nth-child(2) {
    font-size: 14px;
    color: #666;
}

.contactbox p:nth-child(3) {
    width: 180px;
    height: 36px;
    margin: auto;
    border: 1px solid rgb(65, 110, 179);
    color: rgb(65, 110, 179);
    line-height: 36px;
    cursor: pointer;
}
</style>
